import BaseService from "./geral/BaseService";

const base = "BloqueioDesdobramentoBL";

export default class BloqueioBlService extends BaseService{
    
    constructor(props){
        super(props)
    }

    Listar = (numBl, operacao) => {
        return super.httpGet(`/${base}/Listar?numeroBl=${numBl}&operacao=${operacao}`);
    }

    ListarOperacao = () => {
        return super.httpGet(`/${base}/ListarOperDetalhes`);
    }

    Editar = (blBloq) => {
        return super.httpPost(`/${base}/Editar`,blBloq);
    }

    Excluir = (blBloq) => {
        return super.httpPost(`/${base}/Excluir`,blBloq);
    }

    Inserir = (numBl, operacao) => {
        return super.httpPost(`/${base}/Inserir?numeroBl=${numBl}&oper=${operacao}`,);
    }
}


// WEBPACK FOOTER //
// ./src/services/BloqueioBlService.js